import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import AssigneesList from 'modules/tasks/components/AssigneesList'
import TaskDetails from 'modules/tasks/components/TaskDetails'
import { useGetTaskFiles } from 'modules/tasks/hooks/useGetTaskFiles'

import { TaskDetail } from './useTaskDetail'

interface ContentProps {
  task: TaskDetail
  canSeePersonalInfo: boolean
  canEditPersonalInfo: boolean
  contractVersions: ContractVersions
  canEmployeeManageAnyEmployeeFolder: boolean
}

export const TaskElementContent = observer(
  ({
    task,
    canSeePersonalInfo,
    canEditPersonalInfo,
    contractVersions,
    canEmployeeManageAnyEmployeeFolder,
  }: ContentProps) => {
    const { files, loading } = useGetTaskFiles(task.id)

    const dueOn = task.dueOn

    if (loading) {
      return null
    }
    return (
      <TaskDetails
        task={task}
        assignees={
          task.assignees?.length > 0 && (
            <AssigneesList count={task.assigneesCount} assignees={task.assignees} />
          )
        }
        affectee={task.affectees?.length > 0 && <AssigneesList assignees={task.affectees} />}
        dueOn={dueOn}
        files={files}
        loadingFiles={loading}
        canSeePersonalInfo={canSeePersonalInfo}
        canEditPersonalInfo={canEditPersonalInfo}
        contractVersions={contractVersions}
        canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      />
    )
  }
)
